import { Component } from '@angular/core';

import { ButtonColor } from '@freelancer/ui/button/button.component';

@Component({
  selector: 'app-navigation-secondary-community',
  template: `
    <app-bar flTrackingSection="SubnavCommunity">
      <app-bar-item
        link="/community"
        [exactLink]="true"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Community"
      >
        Community
      </app-bar-item>
      <app-bar-item
        link="/community/experts"
        [exactLink]="true"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Experts"
      >
        Experts
      </app-bar-item>
      <app-bar-item
        link="/showcase"
        [exactLink]="true"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Showcase"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        link="/community/my-articles"
        [exactLink]="true"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="MyPosts"
      >
        My Posts
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation community bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryCommunityComponent {
  ButtonColor = ButtonColor;
}



// WEBPACK FOOTER //
// ./src/app/navigation-secondary/navigation-secondary-community.component.ts